import React from 'react';

const ImageArea = (props) => {
    return (
        <div className="p-input__image">
            <img src="https://firebasestorage.googleapis.com/v0/b/nitaku-dev-2d298.appspot.com/o/image%2Fno-image-1.jpg?alt=media&token=430fe67b-45f4-4f9a-9839-d980ff6c8c71"
                 id={props.id + "-thumb"} onClick={() => props.upload(props.id)} alt={"A thumbnail of the question"} />
            <input id={props.id} type="file" data-name="" onChange={e => props.preview(props.id, e)}/>
            <button onClick={() => props.delete(props.id)}>&times;</button>
        </div>
    )
};

export default ImageArea